export default __webpack_public_path__ + "static/media/favicon.71c6fd89.ico";